// extracted by mini-css-extract-plugin
export var pillWrapper = "_ic-0";
export var showOverflow = "_ic-1";